export const basemaps = {
  light: {
    id: "light",
    name: "Light",
    url: "https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}@2x.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
  },
  dark: {
    id: "dark",
    name: "Dark",
    url: "https://{s}.basemaps.cartocdn.com/dark_nolabels/{z}/{x}/{y}@2x.png",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
  },
  satellite: {
    id: "satellite",
    name: "Satellite",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    attribution: "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
  },
};

// Only displaying these in production because they are pay-as-you-go.
// For testing purposes just remove the conditional.
export const labels = {
  light: {
    english: {
      id: "light",
      name: "Labels light",
      url: process.env.NODE_ENV === "production"
        ? "https://api.mapbox.com/styles/v1/airqast/cjrkrtp2m9kh32smyg0shwvxf/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWlycWFzdCIsImEiOiJjam1ydXJucTkwdTVqM3FsOGdxcnkwdHV4In0.zM8gtmOuKEDz8zGCFCtwiw"
        : "",
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
    },
    chinese: {
      id: "light",
      name: "Labels light",
      url: process.env.NODE_ENV === "production"
        ? "https://api.mapbox.com/styles/v1/airqast/cjn1w9f1a5onk2smqm7gsz3gi/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWlycWFzdCIsImEiOiJjam1ydXJucTkwdTVqM3FsOGdxcnkwdHV4In0.zM8gtmOuKEDz8zGCFCtwiw"
        : "",
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
    },
  },
  dark: {
    english: {
      id: "dark",
      name: "Labels dark",
      url: process.env.NODE_ENV === "production"
        ? "https://api.mapbox.com/styles/v1/airqast/cjrkricjf3brw2tmcphtoc5sm/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWlycWFzdCIsImEiOiJjam1ydXJucTkwdTVqM3FsOGdxcnkwdHV4In0.zM8gtmOuKEDz8zGCFCtwiw"
        : "",
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
    },
    chinese: {
      id: "dark",
      name: "Labels dark",
      url: process.env.NODE_ENV === "production"
        ? "https://api.mapbox.com/styles/v1/airqast/cjn1vyswfdeoi2spgu3ij73aa/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiYWlycWFzdCIsImEiOiJjam1ydXJucTkwdTVqM3FsOGdxcnkwdHV4In0.zM8gtmOuKEDz8zGCFCtwiw"
        : "",
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>',
    },
  },
  none: {
    english: { id: "none", name: "None", url: "", attributions: null },
    chinese: { id: "none", name: "None", url: "", attributions: null },
  },
};

export const languages = [
  { label: "Chinese", value: "chinese" },
  { label: "English", value: "english" },
];

export const citiesInfo = [
  {
    label: 'Shanghai',
    value: 'Shanghai',
    location: { lat: '31.2304', long: '121.4737' }
  },
  {
    label: 'Mudu',
    value: 'Mudu',
    location: { lat: '31.2589', long: '120.5172' },
  },
  {
    label: 'Jiangdu',
    value: 'Jiangdu',
    location: { lat: '32.4347', long: '119.5700' }
  }
]



// WEBPACK FOOTER //
// ./src/components/map/constants.js